// Frontend analytics helper — GA4 + Meta Pixel event tracking.
// IDs are loaded once from /api/settings/public via Analytics.jsx; this module
// exposes pure event-firing helpers that no-op safely when no IDs are configured.

const W = typeof window !== "undefined" ? window : {};

function gtagEvent(name, params) {
    if (!W.gtag) return;
    try { W.gtag("event", name, params || {}); } catch (e) { /* never break the app for analytics */ }
}

function fbq(name, params) {
    if (!W.fbq) return;
    try { W.fbq("track", name, params || {}); } catch (e) { /* never break the app for analytics */ }
}

// Map cart items → GA4 item array
function ga4Items(items) {
    return (items || []).map((i, idx) => ({
        item_id: i.product_slug || i.id || `idx-${idx}`,
        item_name: i.product_name || i.name || "Signia Styletto",
        item_brand: "Signia",
        item_variant: i.color || i.side || "",
        item_category: "Hearing Aid",
        price: i.price || 0,
        quantity: i.qty || 1,
    }));
}

function fbContents(items) {
    return (items || []).map((i) => ({
        id: i.product_slug || i.id,
        quantity: i.qty || 1,
        item_price: i.price || 0,
    }));
}

export function trackAddToCart({ item }) {
    const items = ga4Items([item]);
    const value = (item.price || 0) * (item.qty || 1);
    gtagEvent("add_to_cart", { currency: "INR", value, items });
    fbq("AddToCart", { currency: "INR", value, contents: fbContents([item]), content_type: "product" });
}

export function trackBeginCheckout({ items, value, coupon }) {
    gtagEvent("begin_checkout", { currency: "INR", value, coupon, items: ga4Items(items) });
    fbq("InitiateCheckout", { currency: "INR", value, num_items: (items || []).length, contents: fbContents(items), content_type: "product" });
}

export function trackPurchase({ orderNumber, items, value, coupon, paymentMethod }) {
    gtagEvent("purchase", {
        transaction_id: orderNumber,
        currency: "INR",
        value,
        coupon,
        payment_type: paymentMethod,
        items: ga4Items(items),
    });
    fbq("Purchase", { currency: "INR", value, contents: fbContents(items), content_type: "product" });
}

export function trackWhatsAppClick({ productSlug, productName, sourcePage }) {
    gtagEvent("whatsapp_click", { product_slug: productSlug || "", product_name: productName || "", source_page: sourcePage || "" });
    fbq("Contact", { method: "whatsapp", content_name: productName || "Styletto IX" });
}

export function trackUpgradeLead({ currentBrand, currentModel }) {
    gtagEvent("upgrade_lead", { current_brand: currentBrand || "", current_model: currentModel || "" });
    fbq("Lead", { content_name: "Upgrade Exchange", custom_event: "upgrade_lead" });
}

export function trackTrialLead({ city }) {
    gtagEvent("trial_lead", { city: city || "" });
    fbq("Lead", { content_name: "Free Trial Booking", custom_event: "trial_lead" });
}

export function trackPageView(path) {
    if (W.gtag && W.__GA4_ID) {
        W.gtag("event", "page_view", { page_path: path, page_location: W.location.href });
    }
    fbq("PageView");
}
